import { Alert, Button, Group, Paper, Stack, Text } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { CustomerDto } from "@/models/club";
import CustomerItem from "@/modules/customer/list/components/customerItem";
import { isMyCustomer } from "@/services/customer/membership";
import useAssignCustomer from "../hooks/useAssignCustomer";

export default function FoundCustomer({ customer, phoneNumber, close }: {
  customer: CustomerDto;
  phoneNumber: string;
  close?: (customerId: number) => void;
}) {
  const membership = useQuery({
    queryKey: ["customer-membership", customer.id, phoneNumber],
    queryFn: () => isMyCustomer(customer.id!, phoneNumber),
    enabled: Boolean(customer.id),
    retry: false,
    staleTime: 0,
  });
  const assignment = useAssignCustomer({ doNavigate: true, close });
  if (!customer.id) return <Alert color="red">اطلاعات مشتری کامل نیست. شماره را دوباره جست‌وجو کنید.</Alert>;
  if (membership.data === true) return <Stack gap="xs">
    <Text size="sm" c="dimmed">این مشتری در فهرست مشتریان شماست.</Text>
    <CustomerItem customer={customer} close={close} />
  </Stack>;
  return <Stack gap="sm">
    <Paper withBorder radius="md" p="md">
      <Group justify="space-between" gap="md">
        <Stack gap={4}>
          <Text fw={600}>{`${customer.firstName ?? ""} ${customer.lastName ?? ""}`.trim() || "مشتری بدون نام"}</Text>
          <Text size="sm" c="dimmed" dir="ltr">{customer.phoneNumber || phoneNumber}</Text>
        </Stack>
        <Button type="button" loading={assignment.isLoading || membership.isFetching}
          disabled={membership.data !== false || assignment.isSuccess}
          onClick={() => assignment.mutate({ customerId: customer.id })}>
          افزودن به مشتریان من
        </Button>
      </Group>
    </Paper>
    {membership.isError ? <Alert color="red">بررسی فهرست مشتریان انجام نشد.<Button type="button" variant="subtle" onClick={() => void membership.refetch()}>تلاش دوباره</Button></Alert>
      : <Text size="sm" c="dimmed">{membership.isFetching ? "در حال بررسی فهرست مشتریان شما…" : "این شماره قبلاً ثبت شده؛ می‌توانید مشتری را به فهرست خود اضافه کنید."}</Text>}
    {assignment.isError && <Alert color="red">افزودن مشتری انجام نشد. دوباره تلاش کنید.</Alert>}
  </Stack>;
}
